/* eslint-disable react/no-multi-comp */
/* eslint-disable jsx-a11y/label-has-for */

import { withTicketPreview } from 'ducks/ticketing/components'
import Label from '../Label'

const Preview = withTicketPreview(
  ({
    delayedShowTicketPreviewModal,
    cancelDelayedShowTicketPreviewModal,
    children,
  }) => {
    return (
      <span
        onMouseMove={delayedShowTicketPreviewModal}
        onMouseLeave={cancelDelayedShowTicketPreviewModal}
        onClick={cancelDelayedShowTicketPreviewModal}
      >
        {children}
      </span>
    )
  }
)

const avatarComponent = agent => {
  if (!agent) return null
  const avatarUrl = agent.avatarUrl
  const actorInitials = agent.initials
  const styles = { backgroundImage: `url(${avatarUrl})` }
  return (
    <div className="avatar" style={styles}>
      {!avatarUrl && actorInitials}
    </div>
  )
}

class InnerListItem extends React.PureComponent {
  onClick = e => {
    const { conversationId, navigateToConversation } = this.props
    if (e.metaKey || e.ctrlKey) {
      return true
    }
    e.stopPropagation()
    e.preventDefault()
    navigateToConversation(conversationId)
    return true
  }

  onCheckboxClick = () => {
    const { conversationId, toggleConversationSelection } = this.props
    toggleConversationSelection(conversationId)
  }

  onCloseOrOpenClick = e => {
    const {
      conversationId,
      isCloseable,
      openConversation,
      closeConversation,
    } = this.props
    e.stopPropagation()
    // eslint-disable-next-line no-unused-expressions
    isCloseable
      ? closeConversation(conversationId)
      : openConversation(conversationId)
  }

  onUnreadIndicatorClick = e => {
    const { conversationId, isUnread, markAsRead, markAsUnread } = this.props
    e.stopPropagation()
    // eslint-disable-next-line no-unused-expressions
    isUnread ? markAsRead(conversationId) : markAsUnread(conversationId)
  }

  render() {
    if (!this.props.present) return null
    const {
      conversationId,
      assignmentLabel,
      customerLabelFull,
      messageCount,
      subject,
      snippetText,
      snippetAuthor,
      snippetType,
      timestamp,
      labelIds,
      hasCollision,
      collidingAgent,
      collisionType,
      collisionOperation,
      hasAttachments,
      selected,
      isStarred,
      mailboxColor,
      hasDraft,
    } = this.props

    //
    return (
      <div className="sui inner">
        <div className="left">
          <div className="ui checkbox" onClick={this.onCheckboxClick}>
            <input type="checkbox" checked={selected} />
            <label />
          </div>
        </div>
        <a href={`/tickets/${conversationId}`} onClick={this.onClick}>
          <div className="right">
            <div className="top">
              {hasCollision && (
                <span className={['collision', collisionType].join(' ')}>
                  {avatarComponent(collidingAgent)}
                  <span className="chip">
                    <span className="name">
                      {collidingAgent && collidingAgent.shortName}
                    </span>{' '}
                    {collisionOperation}
                  </span>
                </span>
              )}
              {isStarred && <span className="Icon Icon-star" />}
              <span className="conversation-number">#{conversationId}</span>
            </div>
            <div className="datetime">{timestamp}</div>
          </div>
          <div className="middle">
            {mailboxColor && (
              <div className="mailbox-indicator">
                <div
                  className="inner"
                  style={{ backgroundColor: mailboxColor }}
                />
              </div>
            )}
            <div className="header">
              <Preview ticketId={conversationId}>
                <span className="customer">{customerLabelFull}</span>

                {assignmentLabel && (
                  <span className="assignment">&gt; {assignmentLabel}</span>
                )}
              </Preview>
              {messageCount > 0 && (
                <span className="count">{messageCount}</span>
              )}
              {hasAttachments && <span className="Icon Icon-attachment" />}
              {labelIds &&
                labelIds.length > 0 && (
                  <span className="labels">
                    {labelIds.map(id => <Label labelId={id} />)}
                  </span>
                )}
            </div>
            <div className="message">
              <div className="contents">
                <span className="subject">{subject}</span>
                <span className="separator">–</span>
                <span className={['snippet', snippetType].join(' ')}>
                  {!hasDraft &&
                    snippetAuthor && (
                      <span className="author">
                        <span>{snippetAuthor}</span>:{' '}
                      </span>
                    )}
                  {hasDraft && <span className="author">Draft: </span>}
                  {snippetText}
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    )
  }
}

export default InnerListItem
